import Vue from 'vue'

// Users
Vue.component('users', require('./Users/Index'))
Vue.component('user-form', require('./Users/Form').default);
Vue.component('user-image', require('./Users/Image').default);
Vue.component('user-create', require('./Users/Create').default);
Vue.component('user-delete', require('./Users/Delete').default);
Vue.component('user-account', require('./Users/Account').default);
Vue.component('user-profile', require('./Users/Profile').default);
Vue.component('user-presentation-card', require('./Users/PresentationCard').default);
// Vue.component('user-notification-emails', require('./Users/NotificationEmails').default);

// Billing & Cards
Vue.component('payment-methods', require('./Billing/Index'))
Vue.component('delete-payment-method', require('./Billing/DeletePaymentMethod').default);
Vue.component('default-payment-method', require('./Billing/DefaultPaymentMethod').default);
Vue.component('create-payment-method-modal', require('./Billing/CreatePaymentMethod').default);

// Roles
Vue.component('roles', require('./Roles/Index'))
Vue.component('role-form', require('./Roles/Form').default);
Vue.component('role-create', require('./Roles/Create').default);
Vue.component('role-update', require('./Roles/Update').default);
Vue.component('role-delete', require('./Roles/Delete').default);

// Permissions
Vue.component('permissions', require('./Permissions/Index'))
Vue.component('permission-create', require('./Permissions/Create').default);
Vue.component('permission-update', require('./Permissions/Update').default);
Vue.component('permission-delete', require('./Permissions/Delete').default);

// Energy Code
Vue.component('energy-code-current', require('./EnergyCode/CurrentStatus').default);
Vue.component('energy-code-active-status', require('./EnergyCode/ActiveStatus').default);
